import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './customerList.css'
// Import your images
import Tejarat from '../../assets/images/partners/pec-logo-new.png';
import Dade from '../../assets/images/partners/dade.png';
import Dena from '../../assets/images/partners/dena.jpg';
import Parsian from '../../assets/images/partners/parsian.png';
import TopLogo from '../../assets/images/partners/top.svg';
// import TopLogo from '../../assets/images/partners/logo-top-fa.svg';
const ProductsItem = () => {
  const settings = {
    autoplay: true, // Enable auto-sliding
    autoplaySpeed: 3000, 
    responsive: [
      {
        breakpoint: 3000, // Max screen width
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4, // Show 1 slide on small screens
          slidesToScroll: 1,
          arrows: false, // Hide arrows on small screens
        },
      },
    ],
  };

  return (
    <div className='customer-list'>
      <Slider {...settings} >
        <div className="slide-item">
          <img src={Tejarat} alt="Tejarat" width={100} height={100}/>
        </div>
        <div className="slide-item">
          <img src={Dade} alt="Dade" width={100} height={100}/>
        </div>
        <div className="slide-item">
          <img src={TopLogo} alt="Dade" width={100} height={100}/>
        </div>
        <div className="slide-item">
          <img src={Dena} alt="Dena" width={100} height={100}/>
        </div>
        <div className="slide-item">
          <img src={Parsian} alt="Parsian" style={{height: 'auto',maxWidth: '40px'}}/>
        </div>
      </Slider>
    </div>
  );
};

export default ProductsItem;
